<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary" 
        >
          <b-navbar-brand center>Vendor Details</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button variant="warning" class="btn-sm" @click="goToMain">New Vendor</b-button>

              <b-button
                size="sm"
                class="ml-2"
                :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                @click="truckSize('Excel')"
                variant="outline-info"
                > {{ ExcelBtnName }}
                <b-spinner
                  v-if="ExcelBtnName != 'Export as Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
              
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <b-container fluid>
              <!-- User Interface controls -->
              <b-row>
                <b-col md="12" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" v-model="filter" placeholder="Type to Search"/>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table
                  show-empty
                  stacked="md"
                  :items="viewDriverMaster"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                >
                  <template slot="refuelStationId" slot-scope="row0">
                    <span>{{row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="vendorName" slot-scope="row1">
                    <span
                      @click="viewRefuelPage(row1.item.refuelStationId)"
                      class="showMoreData"
                    >{{row1.item.vendorName}}</span>
                  </template>

                  <template slot="isRefuelActive" slot-scope="row0">
                    <div v-if="adminToggle == 'Admin'" :id="'row' + row0.item.refuelStationId">
                      <md-switch
                        :id="'approval' + row0.item.refuelStationId"
                        name="approval"
                        class="md-primary"
                        :value="row0.item.isRefuelActive == 1 ? true : false"
                        @change="activateUser(row0.item)"
                      >
                        <h6>
                          <br/>
                          <b-badge style="margin-left: -45px">{{
                            row0.item.isRefuelActive == 1 ? "Active" : "In-Active"
                          }}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row' + row0.item.refuelStationId">
                      <h6>
                        <b-badge>{{
                          row0.item.isRefuelActive == 1 ? "Active" : "In-Active"
                        }}</b-badge>
                      </h6>
                    </div>
                </template>

                  <!-- <md-button
                            class="md-icon-button md-raised md-dense"
                            @click="deleteData(item1.refuelStationId)"
                          >
                            <md-icon>delete_sweep</md-icon>
                          </md-button> -->
                </b-table>
              </div>

              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0 pull-right"
                  />
                </b-col>
              </b-row>
            </b-container>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>
  </div>
</template>



<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/vendorMaster/viewVendorMaster");
      this.truckSize("Normal");
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export as Excel",
      fields: [
        {
          key: "refuelStationId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "vendorName",
          label: "Vendor Name",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "selectVendorType",
          label: "Vendor Type",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "gstIn",
          label: "GSTIN",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "contactPersonName",
          label: "Contact Person",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "contactNumber",
          label: "Contact No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "isRefuelActive",
          label: "Status",
          sortable: true,
          sortDirection: "desc"
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      isLoading: true,
      driverName: "",
      driverContact: "",
      driverWorkingYear: "",
      excelUpload: "",
      driverEsic: "",
      accountNo: "",
      deleteId: "",
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },

      validate: true,
      addDriverError: "",
      viewDriverMaster: [],
      indexNew: "",
      deleteId: "",
      itemObj: {},
      adminToggle: this.$sessionsStorage.get("designation")
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  mounted() {
    // this.JqueryFun();
  },
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    // Loading
    CustomLoader,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToMain() {
      this.$router.push({
        path: "/vendorMaster/vendorMaster"
      });
    },
    JqueryFun() {
      return $(function() {
        return $("#vendorView").DataTable();
      });
    },

    expandEvent(e) {
      e.preventDefault();
    },

    viewRefuelPage(refuelID) {
      // console.log(driverID);
      this.$sessionsStorage.set("editRefuelId", refuelID);
      this.$router.push({
        path: "/vendorMaster/vendorMaster"
      });
    },

    truckSize(type) {
      this.isLoading = true;
      let type_Size = {
        refuel: "refuel",
        type: type
      };

      if(type == "Excel"){
        this.ExcelBtnName = "Downloading....";
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewVendorMaster.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.viewDriverMaster = data.refuelLocationDetails;
            this.totalRows = data.refuelLocationDetails.length;

            if (type == "Excel") {
              if (data.refuelLocationDetails.length > 0) {
                this.viewDriverMaster = data.refuelLocationDetails;
                this.totalRows = data.refuelLocationDetails.length;
                this.ExcelBtnName = "Export as Excel";
              }
              window.location.href = `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.refuelLocationDetails.length > 0) {
                this.viewDriverMaster = data.refuelLocationDetails;
                this.totalRows = data.refuelLocationDetails.length;
                console.log("Vendor Master Master List response=>", data);
              }
            }

            //  console.log("fsf",data.truckSizeDetails)
            this.JqueryFun();
            this.isLoading = false;
          }
        })
        .catch(error => {});
    },

    downloadExcel() {
      let excelName = {
        excelName: "VendorMaster",
        validExcel: "yes"
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/downloadMasterExcel.php`,
        data: JSON.stringify(excelName),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            // console.log(data);
            // console.log(data.link12);

            window.open(data.link12);
          }
        })
        .catch(error => {});
    },

    onFileChange() {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files[0];
      var formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        formData.append(`vendorMaster[]`, files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" }
      };

      axios
        .post(`${URL_BASE}/uploadExcelDataMaster.php`, formData, config)
        .then(result => {
          console.log(result.data);
          if (result.data == "Only XLXS Format Support") {
            this.alert.content = "Only .xlxs format support";
          } else {
            this.alert.content = result.data;
          }
          this.$refs["addPop"].open();
          this.truckSize("Normal");
        })
        .catch(err => {
          throw err;
        });
    },
    deleteData(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "refuelstationmaster",
          tableId: "refuelStationId",
          tableIsActive: "isRefuelActive",
          tableVal: this.deleteId
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deleteData.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (
              data.clientId != "" &&
              
              status == 200 &&
              data
            ) {
              this.truckSize("Normal");
              this.JqueryFun();
              // console.log(data);
            }
          })
          .catch(error => {});
      }
    },
    activateUser(item, index) {
      // $("#approval" + id).val();

      this.itemObj = item;
      this.indexNew = index;

      this.deleteId = item.refuelStationId;

      this.itemObj.isRefuelActive = this.itemObj.isRefuelActive == 1 ? 0 : 1;
      let paylod = {
        tableName: "refuelstationmaster",
        tableId: "refuelStationId",
        tableIsActive: "isRefuelActive",
        value1: this.itemObj.isRefuelActive,
        tableVal: this.deleteId,
        isMailSend:'No',
        manual:'No',
      };

      
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/activateUser.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          console.log("Salil Result => ", result);
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.getdata();
          }
        })
        .catch((error) => {});

      // this.alert.content = true
      //   ? "Are you sure you want to Activate this User?"
      //   : "Are you sure you want to Deactivate this User?";
      // this.$refs["addPop6"].open();
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// viewVendorMaster.vue?6192a1a2